import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { AgentData } from "../interfaces/agent.interface";

// What we expect
export interface AuthState {
  agentData: AgentData | null;
}

// What we initially have
const initialState: AuthState = {
  agentData: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        agentData: Omit<AgentData, 'agent_password'>;
      }>
    ) => {
      //Save to local storage
      localStorage.setItem("auth:user", JSON.stringify(action.payload.agentData));
      state.agentData = action.payload.agentData as AgentData;
    },
    logout: (state) => {
      // Clear out data from local storage
      localStorage.removeItem("auth:user");
      state.agentData = null;
      localStorage.clear();
    },
  },
});

// Export Selectors for selecting the state
export const selectAuth = (state: RootState): AuthState => state.auth;

// Export Action
export const { setUser, logout } = authSlice.actions;

export const selectUserDetails = (state: RootState) => ({
  agentData: state.auth.agentData,
});

export default authSlice.reducer;